import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Translator from '%app/js/common/services/translator';
import { router } from '%app/js/common/services/router';
import useCookieConsentChoices from '%paysera_service_agreement/js/CookiesUserAgreement/hook/useCookieConsentChoices';
import MaterialSymbol from '../MaterialSymbol';
import CookieConsentCategorySelection from './CookieConsentCategorySelection';

const CONTENT_SX = {
    p: { xs: 2, md: 3 },
};

const BODY_SX = {
    '& a': {
        color: 'primary.text',
    },
};

const ACTIONS_SX = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    mt: 2,
    justifyContent: { xs: 'flex-start', md: 'flex-end' },
};

function CookieConsentContent({ closeBanner }) {
    const [collapseOpen, setCollapseOpen] = useState(false);
    const { acceptRecommended, acceptOnlyNecessary } = useCookieConsentChoices(closeBanner);

    const toggleCollapse = useCallback(() => {
        setCollapseOpen(previous => !previous);
    }, []);

    const bodyHtml = Translator.trans(
        'service_agreement_cookies.body',
        {
            // eslint-disable-next-line babel/camelcase
            cookies_information_link: router.generate(
                'evp_ticket_frontend.static_page.cookies',
                {},
            ),
        },
    );

    return (
        <Box sx={CONTENT_SX} data-testid="redesign-cookie-consent-content">
            <Typography
                variant="body2"
                sx={BODY_SX}
                dangerouslySetInnerHTML={{ __html: bodyHtml }}
            />
            <Box sx={ACTIONS_SX}>
                <Button
                    color="secondary"
                    onClick={toggleCollapse}
                    endIcon={<MaterialSymbol name={collapseOpen ? 'expand_less' : 'expand_more'} />}
                    data-testid="redesign-cookie-consent-customise"
                >
                    {Translator.trans('service_agreement_cookies.button.customise')}
                </Button>
                <Button
                    variant="text"
                    color="secondary"
                    onClick={acceptOnlyNecessary}
                    data-testid="redesign-cookie-consent-only-necessary"
                >
                    {Translator.trans('service_agreement_cookies.button.only_necessary')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={acceptRecommended}
                    data-testid="redesign-cookie-consent-accept-recommended"
                >
                    {Translator.trans('service_agreement_cookies.button.accept_recommended')}
                </Button>
            </Box>
            {collapseOpen && (
                <CookieConsentCategorySelection closeBanner={closeBanner} />
            )}
        </Box>
    );
}

CookieConsentContent.propTypes = {
    closeBanner: PropTypes.func.isRequired,
};

export default React.memo(CookieConsentContent);
